import { AbstractMutableSetthfi6jds1k2h as AbstractMutableSet } from './AbstractMutableSet.mjs';
import { UnsupportedOperationException2tkumpmhredt3 as UnsupportedOperationException } from '../exceptions.mjs';
import {
  KtMutableSetwuwn7k5m570a as KtMutableSet,
  Collection1k04j3hzsbod0 as Collection,
  MutableIterablez3x4ksk1fmrm as MutableIterable,
  Entry2xmjmyutzoq3p as Entry,
} from './Collections.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import { AbstractMutableCollections0bg6c40ztuj as AbstractMutableCollection } from './AbstractMutableCollectionJs.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../hacks.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../js/typeCheckUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var HashMapKeysClass;
function HashMapKeys() {
  if (HashMapKeysClass === VOID) {
    class $ extends AbstractMutableSet() {
      static g9(backing) {
        var $this = this.y7();
        $this.f9_1 = backing;
        return $this;
      }
      p1() {
        return this.f9_1.p1();
      }
      i1() {
        return this.f9_1.p1() === 0;
      }
      t1(element) {
        return this.f9_1.e9(element);
      }
      v3() {
        return this.f9_1.v3();
      }
      v(element) {
        throw UnsupportedOperationException().f8();
      }
      r1(elements) {
        throw UnsupportedOperationException().f8();
      }
      w3(element) {
        return this.f9_1.l9(element);
      }
      m1() {
        return this.f9_1.m9();
      }
      k6() {
        return this.f9_1.n9();
      }
    }
    initMetadataForClass($, 'HashMapKeys', VOID, VOID, [KtMutableSet(), AbstractMutableSet()]);
    HashMapKeysClass = $;
  }
  return HashMapKeysClass;
}
var HashMapValuesClass;
function HashMapValues() {
  if (HashMapValuesClass === VOID) {
    class $ extends AbstractMutableCollection() {
      static i9(backing) {
        var $this = this.i6();
        $this.h9_1 = backing;
        return $this;
      }
      p1() {
        return this.h9_1.p1();
      }
      i1() {
        return this.h9_1.p1() === 0;
      }
      o9(element) {
        return this.h9_1.o3(element);
      }
      t1(element) {
        if (!(element == null ? true : !(element == null)))
          return false;
        return this.o9((element == null ? true : !(element == null)) ? element : THROW_CCE());
      }
      p9(element) {
        throw UnsupportedOperationException().f8();
      }
      v(element) {
        return this.p9((element == null ? true : !(element == null)) ? element : THROW_CCE());
      }
      q9(elements) {
        throw UnsupportedOperationException().f8();
      }
      r1(elements) {
        return this.q9(elements);
      }
      m1() {
        return this.h9_1.r9();
      }
      s9(element) {
        return this.h9_1.t9(element);
      }
      w3(element) {
        if (!(element == null ? true : !(element == null)))
          return false;
        return this.s9((element == null ? true : !(element == null)) ? element : THROW_CCE());
      }
      k6() {
        return this.h9_1.n9();
      }
    }
    initMetadataForClass($, 'HashMapValues', VOID, VOID, [Collection(), MutableIterable(), AbstractMutableCollection()]);
    HashMapValuesClass = $;
  }
  return HashMapValuesClass;
}
var HashMapEntrySetClass;
function HashMapEntrySet() {
  if (HashMapEntrySetClass === VOID) {
    class $ extends HashMapEntrySetBase() {
      static k9(backing) {
        return this.v9(backing);
      }
      m1() {
        return this.u9_1.w9();
      }
    }
    initMetadataForClass($, 'HashMapEntrySet');
    HashMapEntrySetClass = $;
  }
  return HashMapEntrySetClass;
}
var HashMapEntrySetBaseClass;
function HashMapEntrySetBase() {
  if (HashMapEntrySetBaseClass === VOID) {
    class $ extends AbstractMutableSet() {
      static v9(backing) {
        var $this = this.y7();
        $this.u9_1 = backing;
        return $this;
      }
      p1() {
        return this.u9_1.p1();
      }
      i1() {
        return this.u9_1.p1() === 0;
      }
      x9(element) {
        return this.u9_1.aa(element);
      }
      t1(element) {
        if (!(!(element == null) ? isInterface(element, Entry()) : false))
          return false;
        return this.x9((!(element == null) ? isInterface(element, Entry()) : false) ? element : THROW_CCE());
      }
      v3() {
        return this.u9_1.v3();
      }
      y9(element) {
        throw UnsupportedOperationException().f8();
      }
      v(element) {
        return this.y9((!(element == null) ? isInterface(element, Entry()) : false) ? element : THROW_CCE());
      }
      r1(elements) {
        throw UnsupportedOperationException().f8();
      }
      z9(element) {
        return this.u9_1.ba(element);
      }
      w3(element) {
        if (!(!(element == null) ? isInterface(element, Entry()) : false))
          return false;
        return this.z9((!(element == null) ? isInterface(element, Entry()) : false) ? element : THROW_CCE());
      }
      l3(elements) {
        return this.u9_1.ca(elements);
      }
      k6() {
        return this.u9_1.n9();
      }
    }
    initMetadataForClass($, 'HashMapEntrySetBase', VOID, VOID, [KtMutableSet(), AbstractMutableSet()]);
    HashMapEntrySetBaseClass = $;
  }
  return HashMapEntrySetBaseClass;
}
//region block: exports
export {
  HashMapEntrySet as HashMapEntrySet29p2ksc4wcy5i,
  HashMapKeys as HashMapKeys28ggmxpft3hz9,
  HashMapValues as HashMapValues3umcxpfyfunqf,
};
//endregion

//# sourceMappingURL=HashMapEntry.mjs.map
